import CompanyStore from "../Company/CompanyStore";

const setupFunctions = {
  "fawter": function (company) {
    let state;

    if (company.id) {
      this.state.beganSetup = true;
      if (company.legal_name) {
        if (company.has_voucher_template) {
          state = 4;
        } else {
          state = 3;
        }
      } else {
        state = 2;
      }
    } else {
      state = 1;
    }

    return state;
  },

  "ihjoz": function (company) {
    let state;

    if (company.id) {
      this.state.beganSetup = true;
      if (company.legal_name) {
        state = 4;
      } else {
        state = 2;
      }
    } else {
      state = 1;
    }

    return state;
  },

  "default": function (company) {
    let state;

    if (company.id) {
      this.state.beganSetup = true;
      if (company.legal_name) {
        state = 4;
      } else {
        state = 2;
      }
    } else {
      state = 1;
    }

    return state;
  }
};

const setupStages = {
  "fawter": {
    1: (response) => `/merchant/${response.resource.id}/account`,
    2: () => "/templates/new",
    3: () => "/invoices/new"
  },

  "ihjoz": {
    1: (response) => `/merchant/${response.resource.id}/account`,
    2: () => "/events/new"
  },

  "default": {
    1: (response) => `/merchant/${response.resource.id}/account`,
    2: () => "/events/new"
  }
};

class SetupStore {
  constructor (resourceName) {
    this.state = { stage: 1,
      beganSetup: false,
      initialized: false };
    
    if (setupStages[Dashboard.currentTenant.name.toLowerCase()]) {
      this.setupStages = setupStages[Dashboard.currentTenant.name.toLowerCase()];
    } else {
      this.setupStages = setupStages["default"];
    }
  }

  async ensureCurrentState () {
    if (!this.state.initialized) {
      this.state.initialized = true;
      this.refreshState();
    }
  }

  refreshState () {
    let company = CompanyStore.currentCompany;

    if (setupStages[Dashboard.currentTenant.name.toLowerCase()]) {
      this.state.stage = setupFunctions[Dashboard.currentTenant.name.toLowerCase()].bind(this)(company);
    } else {
      this.state.stage = setupFunctions["default"].bind(this)(company);
    }
  }

  beginSetup () {
    this.state.beganSetup = true;
  }

  finishSetup () {
    this.state.stage = 4;
  }
}

export default new SetupStore();
